module.exports = __webpack_public_path__ + "img/便便.3de16b6b.gif";